<template>
  <div class="edit-platform">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">申请充值</div>
    <div class="order-detail-basic">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" hide-required-asterisk label-width="100px" class="demo-ruleForm">
        <el-form-item label="支付日期:" prop="bankPaymentDate">
          <el-date-picker v-model="ruleForm.bankPaymentDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="平台号:" prop="num">
          <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect">
          </el-autocomplete>
          <el-button @click="verifyStore" style="margin-right:10px" round>验证平台</el-button>
          <span v-show="show">平台名称:{{ storeName }}</span>
        </el-form-item>
        <el-form-item label="充值金额:" prop="amount">
          <el-input v-model="ruleForm.amount" clearable></el-input>
        </el-form-item>
        <el-form-item label="虚拟充值:" prop="bonus">
          <el-input v-model="ruleForm.bonus" clearable></el-input>
        </el-form-item>
        <el-form-item label="收款账户:" prop="bankAccountId">
          <el-select v-model="ruleForm.bankAccountId" placeholder="请选择" clearable>
            <el-option v-for="item in bankList" :key="item.id" :label="item.bankName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易单号:" prop="outSerialNo">
          <el-input v-model="ruleForm.outSerialNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="支付凭证:">
          <div class="upload-img">
            <input type="file" name="" id="input_img" @change="upload($event)" />
            <div class="recharge-ok">上传文件</div>
          </div>
          <div id="show_img">
            <img :src="ruleForm.bankVoucher" alt="">
          </div>
          <p style="color: #999">支持格式：.jpg.png ，单个文件不能超过10MB，再次上传将替换</p>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="ruleForm.note" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="edit-button">
        <el-button type="primary" round @click="submitForm('ruleForm')">申请充值</el-button>
      </div>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
 <script>
import imgSrc from '@/assets/images/money.svg'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { chargeApply, bankAccountGetAll } from '@/api/epay'
import { storeQueryListByCode, storeQueryByStoreCode } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  name: 'edit-platform',
  components: {
    CombinedDialog
  },
  data () {
    var bankAccountId = (rule, value, callback) => {
      if (this.ruleForm.amount !== '0' && !this.ruleForm.bankAccountId) {
        callback(new Error('请选择收款账户'))
      } else {
        callback()
      }
    }
    var outSerialNo = (rule, value, callback) => {
      if (this.ruleForm.amount !== '0' && !this.ruleForm.outSerialNo) {
        callback(new Error('请输入交易单号'))
      } else {
        callback()
      }
    }
    return {
      awsSdk: null,
      show: false,
      storeName: '',
      ruleForm: {
        amount: '',
        bankAccountId: '',
        bankPaymentDate: '',
        bankVoucher: '',
        bonus: '',
        note: '',
        outSerialNo: '',
        tradeMethod: 'CHARGE_OFFLINE',
        storeId: ''
      },
      rules: {
        bankPaymentDate: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        amount: [
          { required: true, message: '请填写充值金额', trigger: 'blur' }
        ],
        bonus: [
          { required: true, message: '请填写虚拟充值', trigger: 'blur' }
        ],
        bankAccountId: [
          { validator: bankAccountId, trigger: 'change' }
        ],
        outSerialNo: [
          { validator: outSerialNo, trigger: 'blur' }
        ]
      },
      date: '',
      code: '',
      bankList: []
    }
  },
  watch: {
    date (val) {
      if (val) {
        this.ruleForm.bankPaymentDate = this.$moment(this.date).format('YYYY-MM-DD')
      } else {
        this.ruleForm.bankPaymentDate = ''
      }
    },
    code () {
      this.show = false
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getBankList()
  },
  methods: {
    // 获取收款账户列表
    getBankList () {
      bankAccountGetAll().then(res => {
        this.bankList = res.data.data
      })
    },
    // 验证平台
    verifyStore () {
      storeQueryByStoreCode(this.code).then(res => {
        if (res.data.data.exist) {
          this.ruleForm.storeId = res.data.data.id
          this.storeName = res.data.data.name
          this.show = true
        } else {
          this.$message.error('平台不存在')
        }
      })
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    submitForm (formName) {
      if (!this.show) {
        this.$message.error('请验证平台')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          chargeApply(false, this.ruleForm).then(res => {
            if (res.data.success) {
              this.$message({
                message: '申请成功',
                type: 'success'
              })
              this.$router.push({
                path: '/epay/vpayCharge'
              })
            }
          })
        }
      })
    },
    upload (e) {
      const loading = this.$loading({
        lock: true,
        text: '正在上传',
        spTEXT: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        loading.close()
        return
      }
      if (e.target.files[0].size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        loading.close()
        return
      }
      var file = e.target.files[0]
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.ruleForm.bankVoucher = res
        loading.close()
      })
    },
    handleSelect (item) {
      this.ruleForm.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    }
  }
}
</script>
 <style scoped lang="less">
 // @import "index";
 .edit-platform {
   .el-input {
     @{deep} .el-input__inner {
       //color: #F56C6C;
       -moz-appearance: textfield;
     }
 
     @{deep} .el-input__inner::-webkit-inner-spin-button,
     @{deep} .el-input__inner::-webkit-outer-spin-button {
       -webkit-appearance: none;
       margin: 0;
     }
   }
 }
 
 @deep: ~">>>";
 </style>
